import { Container, useScrollTrigger } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import React, { useEffect, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../Assets/Images/Logo_2.svg"
import SearchContainer from "../../Blocks/SearchContainer/SearchContainer";
import Cart from "./Controls/Cart";
import Controls from "./Controls/Controls";
import Currency from "./Controls/Currency";
import Profile from "./Controls/Profile";
import DrawerContent from "./NavbarComponents/DrawerContent";
import MainItemsContainer from "./NavbarComponents/MainItemsContainer/MainItemsContainer";
import useGetData from "../../../Hooks/useGetData";
import MemoNotifications from "./Controls/Notifications";
interface Props {
  // window?: () => any;
}

const LogoSvg = () => {
  return(
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 470 155">
  <defs>
    <linearGradient id="linear-gradient" x1="0" y1="144.2" x2="470" y2="144.2" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3781c2"/>
      <stop offset="1" stop-color="#3db9ec"/>
    </linearGradient>
    <linearGradient id="linear-gradient-2" x1="346" y1="57.2" x2="336.4" y2="78.3" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#8766ab"/>
      <stop offset="1" stop-color="#8853a3"/>
    </linearGradient>
    <linearGradient id="linear-gradient-3" x1="0" y1="54.8" x2="425.1" y2="54.8" xlinkHref="#linear-gradient"/>
    <linearGradient id="linear-gradient-4" x1="446.7" y1="44.9" x2="427.9" y2="86.1" xlinkHref="#linear-gradient-2"/>
    <linearGradient id="linear-gradient-5" x1="470.2" y1="44.9" x2="451.5" y2="86.1" xlinkHref="#linear-gradient-2"/>
  </defs>
  <path d="M0,134.1h3.3l3,5.9,3-5.9h3.3l-4.8,9.3v7.1h-3.1v-7.1L0,134.1ZM25.2,138.1c1.1,0,2.2.3,3.2.9,1,.6,1.8,1.4,2.3,2.3.6,1,.8,2,.8,3.2s-.3,2.2-.9,3.2c-.6,1-1.3,1.8-2.3,2.3-1,.6-2.1.8-3.2.8-1.7,0-3.2-.6-4.4-1.9-1.2-1.2-1.8-2.8-1.8-4.5s.7-3.5,2.1-4.8c1.2-1.1,2.6-1.7,4.2-1.7ZM25.2,140.9c-.9,0-1.7.3-2.4,1-.6.7-.9,1.5-.9,2.5s.3,1.9.9,2.6c.6.7,1.4,1,2.4,1s1.7-.3,2.4-1c.6-.7.9-1.5.9-2.6s-.3-1.9-.9-2.5c-.6-.7-1.4-1-2.4-1ZM38.6,138.4h3.1v5.9c0,1.1,0,1.9.2,2.4.2.4.4.8.8,1,.3.2.8.4,1.3.4s.9-.1,1.3-.4.6-.6.8-1.1c.1-.4.2-1.1.2-2.2v-6h3v5.2c0,2.1-.2,3.6-.5,4.4-.4,1-1,1.7-1.8,2.2s-1.8.8-3,.8-2.4-.3-3.2-.9c-.8-.6-1.4-1.4-1.7-2.5-.2-.7-.4-2.1-.4-4v-5.1ZM56.1,138.4h2.6v1.5c.3-.6.7-1.1,1.1-1.4s1-.5,1.5-.5.8.1,1.2.3l-.9,2.6c-.4-.2-.6-.3-.9-.3-.5,0-.9.3-1.2.9-.3.6-.5,1.7-.5,3.4v.6s0,4.9,0,4.9h-3v-12.2ZM95,136.8l-2.2,2.2c-1.4-1.5-3-2.2-4.8-2.2s-3,.5-4,1.6c-1.1,1.1-1.6,2.4-1.6,3.9s.6,2.9,1.7,4c1.1,1.1,2.5,1.7,4.2,1.7s2-.2,2.7-.7c.7-.5,1.3-1.2,1.8-2.1h-4.7v-2.9h8.2v.7c0,1.4-.3,2.8-1.1,4.1-.7,1.3-1.7,2.3-2.9,3-1.2.7-2.6,1-4.1,1s-3.2-.4-4.5-1.1c-1.3-.7-2.4-1.8-3.2-3.2-.8-1.4-1.2-2.9-1.2-4.4s.7-4.1,2.1-5.7c1.7-1.9,3.9-2.9,6.6-2.9s2.8.3,4,.8c1,.4,2.1,1.2,3.1,2.3ZM112.1,138.4h3v12.2h-3v-1.3c-.6.6-1.2,1-1.8,1.2-.6.2-1.2.4-1.9.4-1.6,0-2.9-.6-4-1.8-1.1-1.2-1.7-2.7-1.7-4.5s.6-3.4,1.7-4.6c1.1-1.2,2.4-1.8,4-1.8s1.4.1,2,.4c.6.3,1.2.7,1.8,1.2v-1.3ZM108.9,140.9c-.9,0-1.7.3-2.3,1s-.9,1.5-.9,2.6.3,1.9.9,2.6c.6.7,1.4,1,2.3,1s1.7-.3,2.4-1,.9-1.5.9-2.6-.3-1.9-.9-2.6-1.4-1-2.4-1ZM123.1,133.9h3v4.5h1.8v2.6h-1.8v9.5h-3v-9.5h-1.6v-2.6h1.6v-4.5ZM146.2,145.3h-9.7c.1.9.5,1.6,1.1,2.1.6.5,1.4.8,2.3.8s2.1-.4,2.9-1.2l2.6,1.2c-.6.9-1.4,1.6-2.3,2-.9.4-1.9.7-3.2.7-1.9,0-3.4-.6-4.6-1.8-1.2-1.2-1.8-2.7-1.8-4.5s.6-3.4,1.8-4.6c1.2-1.2,2.7-1.8,4.5-1.8s3.4.6,4.6,1.8c1.2,1.2,1.8,2.8,1.8,4.9v.6ZM143.2,142.9c-.2-.7-.6-1.2-1.2-1.7-.6-.4-1.3-.6-2.1-.6s-1.6.2-2.2.7c-.4.3-.8.8-1.1,1.6h6.6ZM151.9,138.4h3l2.4,6.9,2.6-6.9h1.8l2.6,6.8,2.4-6.8h3l-4.4,12.2h-1.9l-2.6-6.9-2.7,6.9h-1.9l-4.4-12.2ZM184.9,138.4h3v12.2h-3v-1.3c-.6.6-1.2,1-1.8,1.2-.6.2-1.2.4-1.9.4-1.6,0-2.9-.6-4-1.8-1.1-1.2-1.7-2.7-1.7-4.5s.6-3.4,1.7-4.6c1.1-1.2,2.4-1.8,4-1.8s1.4.1,2,.4c.6.3,1.2.7,1.8,1.2v-1.3ZM181.7,140.9c-.9,0-1.7.3-2.3,1s-.9,1.5-.9,2.6.3,1.9.9,2.6c.6.7,1.4,1,2.3,1s1.7-.3,2.4-1,.9-1.5.9-2.6-.3-1.9-.9-2.6-1.4-1-2.4-1ZM194.2,138.4h3.1l3.1,7.6,3.5-7.6h3.1l-7.6,16.6h-3.1l2.5-5.4-4.6-11.3ZM224.6,133.9h3v4.5h1.8v2.6h-1.8v9.5h-3v-9.5h-1.6v-2.6h1.6v-4.5ZM241.2,138.1c1.1,0,2.2.3,3.2.9,1,.6,1.8,1.4,2.3,2.3.6,1,.8,2,.8,3.2s-.3,2.2-.9,3.2c-.6,1-1.3,1.8-2.3,2.3-1,.6-2.1.8-3.2.8-1.7,0-3.2-.6-4.4-1.9s-1.8-2.8-1.8-4.5.7-3.5,2.1-4.8c1.2-1.1,2.6-1.7,4.2-1.7ZM241.3,140.9c-.9,0-1.7.3-2.4,1-.6.7-.9,1.5-.9,2.5s.3,1.9.9,2.6c.6.7,1.4,1,2.4,1s1.7-.3,2.4-1c.6-.7.9-1.5.9-2.6s-.3-1.9-.9-2.5c-.6-.7-1.4-1-2.4-1ZM265.9,134.1h8.9v3.1h-5.8v3h5.8v3h-5.8v4.3h5.8v3.1h-8.9v-16.5ZM282,138.4h3v1.2c.7-.6,1.3-1,1.9-1.2.6-.2,1.1-.3,1.7-.3,1.2,0,2.2.4,3,1.3.7.7,1.1,1.8,1.1,3.2v8h-3v-5.3c0-1.5,0-2.4-.2-2.9s-.4-.8-.7-1.1c-.3-.2-.7-.4-1.2-.4s-1.1.2-1.6.6c-.4.4-.7,1-.9,1.7,0,.4-.1,1.2-.1,2.5v4.9h-3v-12.2ZM300.5,133.9h3v4.5h1.8v2.6h-1.8v9.5h-3v-9.5h-1.6v-2.6h1.6v-4.5ZM323.6,145.3h-9.7c.1.9.5,1.6,1.1,2.1.6.5,1.4.8,2.3.8s2.1-.4,2.9-1.2l2.6,1.2c-.6.9-1.4,1.6-2.3,2-.9.4-1.9.7-3.2.7-1.9,0-3.4-.6-4.6-1.8-1.2-1.2-1.8-2.7-1.8-4.5s.6-3.4,1.8-4.6c1.2-1.2,2.7-1.8,4.5-1.8s3.4.6,4.6,1.8c1.2,1.2,1.8,2.8,1.8,4.9v.6ZM320.6,142.9c-.2-.7-.6-1.2-1.2-1.7-.6-.4-1.3-.6-2.1-.6s-1.6.2-2.2.7c-.4.3-.8.8-1.1,1.6h6.6ZM329.9,138.4h2.6v1.5c.3-.6.7-1.1,1.1-1.4s1-.5,1.5-.5.8.1,1.2.3l-.9,2.6c-.4-.2-.6-.3-.9-.3-.5,0-.9.3-1.2.9-.3.6-.5,1.7-.5,3.4v.6s0,4.9,0,4.9h-3v-12.2ZM342.8,133.9h3v4.5h1.8v2.6h-1.8v9.5h-3v-9.5h-1.6v-2.6h1.6v-4.5ZM362.7,138.4h3v12.2h-3v-1.3c-.6.6-1.2,1-1.8,1.2-.6.2-1.2.4-1.9.4-1.6,0-2.9-.6-4-1.8-1.1-1.2-1.7-2.7-1.7-4.5s.6-3.4,1.7-4.6c1.1-1.2,2.4-1.8,4-1.8s1.4.1,2,.4c.6.3,1.2.7,1.8,1.2v-1.3ZM359.5,140.9c-.9,0-1.7.3-2.3,1-.6.7-.9,1.5-.9,2.6s.3,1.9.9,2.6c.6.7,1.4,1,2.3,1s1.7-.3,2.4-1c.6-.7.9-1.5.9-2.6s-.3-1.9-.9-2.6-1.4-1-2.4-1ZM374.6,133.4c.5,0,1,.2,1.4.6.4.4.6.9.6,1.4s-.2,1-.6,1.4-.8.6-1.4.6-1-.2-1.4-.6c-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.4c.4-.4.8-.6,1.4-.6ZM373,138.4h3v12.2h-3v-12.2ZM383.4,138.4h3v1.2c.7-.6,1.3-1,1.9-1.2.6-.2,1.1-.3,1.7-.3,1.2,0,2.2.4,3,1.3.7.7,1.1,1.8,1.1,3.2v8h-3v-5.3c0-1.5,0-2.4-.2-2.9-.1-.5-.4-.8-.7-1.1-.3-.2-.7-.4-1.2-.4s-1.1.2-1.6.6-.7,1-.9,1.7c0,.4-.1,1.2-.1,2.5v4.9h-3v-12.2ZM401.6,138.4h3v1.4c.5-.6,1.1-1,1.7-1.3.6-.3,1.3-.4,2.1-.4s1.4.2,2,.6c.6.4,1.1.9,1.5,1.6.5-.7,1.1-1.3,1.8-1.6.7-.4,1.5-.6,2.3-.6s1.6.2,2.3.6c.7.4,1.1.9,1.4,1.6.3.6.4,1.7.4,3.2v7.1h-3.1v-6.2c0-1.4-.2-2.3-.5-2.8-.3-.5-.9-.7-1.5-.7s-1,.1-1.4.4c-.4.3-.7.7-.9,1.2-.2.5-.3,1.4-.3,2.5v5.5h-3.1v-5.9c0-1.1,0-1.9-.2-2.4-.2-.5-.4-.9-.7-1.1-.3-.2-.7-.4-1.2-.4s-1,.2-1.4.5-.7.7-.9,1.3-.3,1.4-.3,2.6v5.4h-3v-12.2ZM439.6,145.3h-9.7c.1.9.5,1.6,1.1,2.1.6.5,1.4.8,2.3.8s2.1-.4,2.9-1.2l2.6,1.2c-.6.9-1.4,1.6-2.3,2-.9.4-1.9.7-3.2.7-1.9,0-3.4-.6-4.6-1.8-1.2-1.2-1.8-2.7-1.8-4.5s.6-3.4,1.8-4.6c1.2-1.2,2.7-1.8,4.5-1.8s3.4.6,4.6,1.8c1.2,1.2,1.8,2.8,1.8,4.9v.6ZM436.6,142.9c-.2-.7-.6-1.2-1.2-1.7-.6-.4-1.3-.6-2.1-.6s-1.6.2-2.2.7c-.4.3-.8.8-1.1,1.6h6.6ZM446.6,138.4h3v1.2c.7-.6,1.3-1,1.9-1.2.6-.2,1.1-.3,1.7-.3,1.2,0,2.2.4,3,1.3.7.7,1.1,1.8,1.1,3.2v8h-3v-5.3c0-1.5,0-2.4-.2-2.9-.1-.5-.4-.8-.7-1.1-.3-.2-.7-.4-1.2-.4s-1.1.2-1.6.6-.7,1-.9,1.7c0,.4-.1,1.2-.1,2.5v4.9h-3v-12.2ZM465.2,133.9h3v4.5h1.8v2.6h-1.8v9.5h-3v-9.5h-1.6v-2.6h1.6v-4.5Z" fill="url(#linear-gradient)" stroke-width="0"/>
  <g>
    <path d="M361.4,58.6c-.4-.5-.9-1-1.5-1.3l-21.3-12.4c0,0-.1,0-.2-.1-3.2-1.7-7,.6-7,4.3v24.8c0,3.9,4,6.1,7.2,4.2h0s21.2-12.4,21.2-12.4c.7-.4,1.2-.9,1.6-1.4,1.2-1.7,1.2-4,0-5.7Z" fill="url(#linear-gradient-2)" stroke-width="0"/>
    <path d="M362.9,84.6c-3.4,6.1-9.5,8.9-18.9,8.9-18.1,0-31.6-14-31.6-32.1s3.1-16.5,8.7-22.4c6.1-6.5,13.4-9.4,22.6-9.4s15.2,3,19.2,9v-7.4h13.8v61h-13.7v-7.5Z" fill="none" stroke="#3db6ea" stroke-miterlimit="10" stroke-width="1.9"/>
    <path d="M0,93.6V0h31.1c14.6,0,24.7,2.1,34,11.2,8.8,8.6,13.3,20.8,13.3,36.1s-6.4,30.7-18.4,39.4c-8.1,5.9-16.9,7-28.4,7H0ZM59.9,46.7c0-19.5-11-30.8-29.7-30.8h-11.9v61.6h12.2c20,0,29.4-9.5,29.4-30.8ZM165.3,93.6V0h31.1c14.6,0,24.7,2.1,34,11.2,8.8,8.6,13.3,20.8,13.3,36.1s-6.4,30.7-18.4,39.4c-8.1,5.9-16.9,7-28.4,7h-31.6ZM225.2,46.7c0-19.5-11-30.8-29.7-30.8h-11.9v61.6h12.2c20,0,29.4-9.5,29.4-30.8ZM111.7,93.6L78.4,0h19.5l20.3,62.4L138.5,0h19.3l-33.2,93.6h-12.9ZM262.4,22.6l15.9,45.9,17.5-45.9h15.9l-35.3,87.1h-15.7l9.1-23.2-23.6-63.9h16ZM399.2,38.4h-10.2v-13.9h10.2V4.3h15.6v20.2h10.3v13.9h-10.3v55h-15.6v-55Z" fill="url(#linear-gradient-3)" stroke-width="0"/>
    <g>
      <rect x="433.8" y="26.1" width="12.6" height="66.3" rx="4" ry="4" fill="url(#linear-gradient-4)" stroke-width="0"/>
      <rect x="457.4" y="26.1" width="12.6" height="66.3" rx="4" ry="4" fill="url(#linear-gradient-5)" stroke-width="0"/>
    </g>
  </g>
    </svg>
  )
}

function Navbar(props: Props) {
  // const { window } = props;
  const container =
    window !== undefined ? () => window?.document?.body : undefined;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const location = useLocation();

  const navigate = useNavigate();

  let scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  const filterState = useSelector((state: any) => state.filter);
  const { data, error } = useGetData("settings/all", []);
  const updatedLogo = data && data?.settings?.logo;
  const authState = useSelector((state: any) => state.auth);

  return (
    <>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          backgroundColor: scrollTrigger ? "#062132" : "#06213298",
          // backgroundImage: scrollTrigger
          //   ? "linear-gradient(181deg, #1D6E9F00 0%, #3b215a6b 35%, #321C4AE0 53%, #291739e6 84%, #2c203014 100%)"
          //   : "transparent",
          zIndex: "1000",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
        position={scrollTrigger ? "fixed" : "absolute"}
        elevation={scrollTrigger ? 4 : 0}
      >
        <Container
          maxWidth={false}
          sx={{
            maxWidth: {
              mobile: "90%",
              md: "95%",
              xl: "90%",
            },
          }}
        >
          <Toolbar
            sx={{
              width: "100%",
              padding: "0 !important",
              height: {
                mobile: "100px",
                xs: "120px",
                md: "135px",
                xxl: "160px",
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              component="img"
              rel="preload"
              // src={data && updatedLogo }
              src={data ? updatedLogo : Logo }
              // src={ Logo }
              alt="DVDyatii"
              onClick={() => {
                if (location.pathname !== "/") {
                  navigate("/");
                } else {
                  // navigate to home and reload the page
                  window.location.href = "/";
                }
              }}
              className="logo"
              sx={{
                cursor: "pointer",
                // boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.2)",
                width: "100%",
                height: "auto",
                "@media (min-width: 1601px)": {
                  maxWidth: "240px"
                },
                "@media (max-width: 1600px)": {
                  maxWidth: "200px"
                },
                "@media (max-width: 1480px)": {
                  maxWidth: "160px",
                  // maxHeight: "65px",
                },
                "@media (max-width: 1199.99px)": {
                  maxWidth: "120px",
                  minWidth: "80px",
                  maxHeight: "55px",
                },
                "@media (max-width: 373.99.99px)": {
                  maxWidth: "100px",
                  minWidth: "60px",
                  maxHeight: "unset",
                },

                // width: {
                //   mobile: "65px",
                //   lg: "90px",
                //   xl: "100px",
                //   xxl: "1px",
                // },
                // height: {
                //   mobile: "110px",
                //   lg: "90px",
                //   xl: "90px",
                //   xxl: "160px",
                // },
                // height: "auto",
                objectFit: "fill",
              }}
            />
            
            {/* <Box
              component="div"
              // src={data ? updatedLogo : logo}
              // src={data && LogoSvg}
              // alt="logo"
              onClick={() => {
                if (location.pathname !== "/") {
                  navigate("/");
                } else {
                  // navigate to home and reload the page
                  window.location.href = "/";
                }
              }}
              className="logo"
              sx={{
                cursor: "pointer",
                padding: "8px 0",
                
                width: "100%",
                height: "100%",
                "@media (min-width: 1200px)": {
                  maxWidth: "140px",
                  maxHeight: "65px",
                },
                "@media (max-width: 1199.99px)": {
                  maxWidth: "120px",
                  minWidth: "80px",
                  maxHeight: "55px",
                },
                // width: {
                //   mobile: "65px",
                //   lg: "90px",
                //   xl: "100px",
                //   xxl: "1px",
                // },
                // height: {
                //   mobile: "110px",
                //   lg: "90px",
                //   xl: "90px",
                //   xxl: "160px",
                // },
                // height: "auto",
                objectFit: "fill",
              }}
            ><LogoSvg/></Box> */}
            <MainItemsContainer />
            <Box
              sx={{
                display: {
                  // mobile: "none",
                  md: "flex",
                  "@media (max-width: 1024px)": {
                    display: "none",
                  }
                },
              }}
            >
              <SearchContainer />
            </Box>

            <Box
              sx={{
                display: {
                  mobile: "none",
                  md: "flex",
                  "@media (max-width: 1024px)": {
                    display: "none",
                  }
                },
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Controls />
            </Box>

            <Box
              sx={{
                display: {
                  mobile: "none",
                  // lg: "none",
                },
                "@media (max-width: 1024px)": {
                  display: "flex",
                },
                alignItems: "center",
                justifyContent: "center",
                gap: "0.8rem",
                "@media (max-width: 430px)": {
                  gap: '0.45rem'
                }
              }}
            >
              <Profile />
              {authState.isAuthenticated && <MemoNotifications/>}
              <Currency />
              <Cart />
            </Box>

            {/* drawerIcon */}
            <IconButton
              color={location.pathname === "/" ? "secondary" : "primary"}
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                display: "none",
                "@media (max-width: 1024px)": {
                  display: "inline-flex",
                },
                fontSize: { mobile: "1.25rem", xs: "1.5rem" },
                padding: "0 !important",
              }}
            >
              <AiOutlineMenu />
            </IconButton>
            {/* drawerIcon */}
          </Toolbar>
        </Container>
      </AppBar>
      {/* drawer in mobile view */}
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", lg: "none" },

            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: {
                mobile: "300px",
                sm: "350px",
              },
              backgroundImage:
                "linear-gradient(to bottom left, #410a4b, #000000db)",
            },
          }}
        >
          <DrawerContent menus={filterState.menus} />
        </Drawer>
      </Box>
    </>
  );
}

export default React.memo(Navbar);
